// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_g0-0";
export var actionModalContentContainer = "_g0-1";
export var createTagButton = "_g0-2";
export var footerContainer = "_g0-7";
export var fullWidthDivider = "_g0-3";
export var hasCreateTagButton = "_g0-4";
export var noCreateTagButton = "_g0-5";
export var tagsContainer = "_g0-6";
export var tagsModalContentContainer = "_g0-8";